import React, { Component, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import DateFnsUtils from '@date-io/date-fns';
import { MenuItem } from '@material-ui/core';
import MULTISELECT from './MultiselectComponent/MultiselectComponent.jsx';
import { DefaultSelectField } from '../../components/SelectFields';
import { DefaultInputLabel } from '../../components/InputLabels';
import { DefaultDatePicker, DefaultDatePickerProvider } from '../../components/DatePicker';
import {
  DefaultTextField,
  DefaultDateField,
  DefaultTimeField
} from '../../components/TextFields';
import * as utils from '../../utilities/calendarUtilities';
import {
  common,
  COMPONENTS,
  KINDOFBID,
  RESERVE_DOWN_TO,
  VALID_RELATIONS
} from './index';
import frLocale from 'date-fns/locale/fr';
import enLocale from 'date-fns/locale/en-US';
import useEffectAfterMount from "../../hooks/useEffectAfterMount";
import { requiresDateValidation, getDateParameterSequences } from './../../scenes/BidSession/components/BidTable/helpers';
import { LanguageContext } from '../../context/LanguageContext';

// Helper function to get labels - used by class components
// Note: This is a fallback for class components that can't use hooks
// For new components, use the useLanguage() hook instead
const getLabelsFromStorage = () => {
  // Try to get from localStorage first (preferred), then sessionStorage
  const lng = localStorage.getItem('lng') || sessionStorage.getItem('lng');
  if (lng === 'fr') {
    return {
      commonLabels: require('../../labels/labels.french.json').commonLabels,
      WEIGTH_MODE: require('../../labels/labels.french.json').WEIGTH_MODE
    };
  }
  return {
    commonLabels: require('../../labels/labels.json').commonLabels,
    WEIGTH_MODE: require('../../labels/labels.json').WEIGTH_MODE
  };
};

class TEXTFIELD extends Component {
  handleKeyPress = (e) => {
    e.preventDefault();
  };

  render() {
    const defaultValue = this.props.parameter.value
      ? this.props.parameter.value
      : this.props.parameter.defaultValue;
    return (
      <div className="form-item-container">
        <DefaultInputLabel
          htmlFor={`text-field-${this.props.parameter.sequence}`}
        >
          {this.props.parameter.description}
        </DefaultInputLabel>
        <DefaultTextField
          type={isNaN(defaultValue) ? 'text' : 'number'}
          min={isNaN(defaultValue) ? '' : Number(this.props.parameter.minValue)}
          max={isNaN(defaultValue) ? '' : Number(this.props.parameter.maxValue)}
          id={`text-field-${this.props.parameter.sequence}`}
          onChange={this.props.handleFormChange}
          defaultValue={defaultValue}
          onKeyPress={this.handleKeyPress}
          onKeyDown={this.handleKeyPress}
        />
      </div>
    );
  }
}

class FLYTEXTFIELD extends Component {
  constructor(props) {
    super(props);
    this.state = { value: '' };
    this.handleFlyTextField = this.handleFlyTextField.bind(this);
  }
  componentDidMount = () => {
    const value2 = this.props.parameter.value;
    this.setState({
      value: value2
    });
  };
  handleFlyTextField = (e, index) => {
    const value1 = e.target.value;
    const { parameter, handleFormChange } = this.props;
    this.setState({
      value: value1
    });
    handleFormChange(
      e,
      index,
      value1,
      parameter.sequence,
      'text',
      parameter.parameterId
    );
  };
  render() {
    return (
      <div className="form-item-container">
        <DefaultInputLabel htmlFor={this.props.parameter.sequence}>
          {this.props.parameter.description}
        </DefaultInputLabel>
        <DefaultTextField
          type={'text'}
          value={this.state.value}
          onChange={this.handleFlyTextField}
          id={`text-field-${this.props.parameter.sequence}`}
          style={{ zIndex: 2104 }}
        />
      </div>
    );
  }
}

const LISTABLEDATE = (props) => {
  const { language } = useContext(LanguageContext);
  const [controlledDate, setControlledDate] = useState(null);
  const [dateError, setDateError] = useState(false);
  const [dateErrorMessage, setDateErrorMessage] = useState('');

  const isSecondParamSequenceAndNotStationLayover = () => {
    return (props.parameter.sequence === 2 || props.parameter.parameterSequence === 2)&& props.preferenceOptionId !== KINDOFBID.STATION_LAYOVER_ON_DATES_PREFERENCE_ID;
  }

  const isThirdParamSequenceAndStationLayover = () => {
    return (props.parameter.sequence === 3 || props.parameter.parameterSequence === 3) && props.preferenceOptionId === KINDOFBID.STATION_LAYOVER_ON_DATES_PREFERENCE_ID;
  }

  const initDisabled = () => {
    return (props.preferenceOptionId === KINDOFBID.PERIOD_OF_DATES_OFF_PREFERENCE_ID || props.preferenceOptionId === KINDOFBID.STATION_LAYOVER_ON_DATES_PREFERENCE_ID)
      && (props.disabled === true && (isSecondParamSequenceAndNotStationLayover() || isThirdParamSequenceAndStationLayover()));
  }

  const initMinDate = () => {
    let minDateValue = new Date(props.parameter.minValue);
    minDateValue.setMinutes(minDateValue.getMinutes() + minDateValue.getTimezoneOffset());
    if (props.preferenceOptionId === KINDOFBID.PERIOD_OF_DATES_OFF_PREFERENCE_ID || props.preferenceOptionId === KINDOFBID.STATION_LAYOVER_ON_DATES_PREFERENCE_ID) {
      if (props.minDate && (isSecondParamSequenceAndNotStationLayover() || isThirdParamSequenceAndStationLayover())) {
        minDateValue = new Date(props.minDate);
        minDateValue.setMinutes(minDateValue.getMinutes() + minDateValue.getTimezoneOffset());
      }
    }
    return minDateValue;
  }

  const initMaxDate = () => {
    let maxDateValue = new Date(props.parameter.maxValue);
    maxDateValue.setMinutes(maxDateValue.getMinutes() + maxDateValue.getTimezoneOffset());
    return maxDateValue;
  }

  const sequence = `date-picker-${props.parameter.sequence || props.parameter.parameterSequence}`;
  const disabled = initDisabled();
  const minDate = initMinDate();
  const maxDate = initMaxDate();
  const description = props.parameter.description ? props.parameter.description : ' ';

  // Date validation logic
    // Helper function to normalize dates to YYYY-MM-DD format without timezone issues
  const normalizeDateToString = (date) => {
    if (date instanceof Date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    return date;
  };

  const validateDateOrder = (currentDate, allDateValues, parameterSequence) => {

    if (!currentDate || !props.classOptionAttributes) {
      setDateError(false);
      setDateErrorMessage('');
      if (props.onDateError) {
        props.onDateError(props.parameter.sequence || props.parameter.parameterSequence, false);
      }
      return;
    }

    const needsValidation = requiresDateValidation(props.classOptionAttributes);

    if (!needsValidation) {
      setDateError(false);
      setDateErrorMessage('');
      if (props.onDateError) {
        props.onDateError(props.parameter.sequence || props.parameter.parameterSequence, false);
      }
      return;
    }

    const dateSequences = getDateParameterSequences(props.classOptionAttributes);
    const currentSequence = props.parameter.sequence || props.parameter.parameterSequence;
    const currentIndex = dateSequences.indexOf(currentSequence);

    if (currentIndex === -1) {
      setDateError(false);
      setDateErrorMessage('');
      if (props.onDateError) {
        props.onDateError(currentSequence, false);
      }
      return;
    }

    let hasError = false;
    let errorMessage = '';

    // Check if this is the first date field
    if (currentIndex === 0 && dateSequences.length > 1) {
      const nextSequence = dateSequences[1];
      const nextDate = allDateValues ? allDateValues[nextSequence] : null;

      // Normalize dates to strings for consistent comparison
      const normalizedCurrentDate = normalizeDateToString(currentDate);
      const normalizedNextDate = normalizeDateToString(nextDate);

      if (nextDate && normalizedCurrentDate > normalizedNextDate) {
        hasError = true;
        errorMessage = 'Start date cannot be after end date';
      }
    }

    // Check if this is the second date field
    if (currentIndex === 1) {
      const prevSequence = dateSequences[0];
      const prevDate = allDateValues ? allDateValues[prevSequence] : null;

      // Normalize dates to strings for consistent comparison
      const normalizedCurrentDate = normalizeDateToString(currentDate);
      const normalizedPrevDate = normalizeDateToString(prevDate);

      if (prevDate && normalizedCurrentDate < normalizedPrevDate) {
        hasError = true;
        errorMessage = 'End date cannot be before start date';
      }
    }

    // Update local state only if we have a validation result
    // Otherwise, rely on props.dateErrorMessage from parent
    if (hasError || errorMessage) {
      setDateError(hasError);
      setDateErrorMessage(errorMessage);
    } else {
      // Clear local error state, let props take precedence
      setDateError(!!props.dateErrorMessage);
      setDateErrorMessage('');
    }

    if (props.onDateError) {
      props.onDateError(currentSequence, hasError, errorMessage);
    }
  };

  const handleChange = (event, date, index) => {

    let processedDate;

    if (props.preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE || props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES || props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) {
      processedDate = event;
      setControlledDate(event);
      props.handleFormChange(null, date, index, props.parameter.sequence || props.parameter.parameterSequence, 'date', props.parameter.parameterId);
    } else {
      processedDate = event.target.value;
      setControlledDate(event.target.value);
      props.handleFormChange(null, event.target.value, index, props.parameter.sequence || props.parameter.parameterSequence, 'date', props.parameter.parameterId);
    }

    // Create updated allDateValues to include the current change for immediate validation
    const currentSequence = props.parameter.sequence || props.parameter.parameterSequence;
    const updatedAllDateValues = {
      ...props.allDateValues,
      [currentSequence]: processedDate
    };

    // Call parent's updateAllDateValues to keep parent state in sync
    if (props.updateAllDateValues) {
      props.updateAllDateValues(currentSequence, processedDate);
    }

    // Validate immediately with updated values
    setTimeout(() => {
      validateDateOrder(processedDate, updatedAllDateValues);
    }, 0);
  };

  const disableInactiveDates = (date) => {
    if (props.preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE || props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES || props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) {
      const dateToTest = utils.formatActivityDateWithNoTime(date);
      if (props.pairingdate.pairingdate !== undefined && props.pairingdate.pairingdate.includes(dateToTest)) {
        return false;
      }
      return true;
    }
    return false;
  };

  useEffectAfterMount(() => {
    if (props.preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE || props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES || props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) {
      setControlledDate(null);
      props.setSelectedParameterValues(props.parameter.sequence - 1 || props.parameter.parameterSequence - 1, null, props.parameter.parameterId);
      props.disableDialogSaveButton();
    }
  }, [props.pairingName]);

  useEffect(() => {
    // For PAIRING_START_ON_DATE, SPECIFIC_PAIRING_ON_DATES, and SPECIFIC_PAIRING_STARTING_ON_DATES, use selectedParameterValues if present, otherwise use parameter.value (editing), but never defaultValue
    const isPairingBid =
      props.preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE ||
      props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES ||
      props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES;

    let valueFromSelected = null;
    if (props.selectedParameterValues && Array.isArray(props.selectedParameterValues)) {
      const found = props.selectedParameterValues.find(
        v => v && v.parameterId === props.parameter.parameterId
      );
      if (found && found.value) {
        valueFromSelected = found.value;
      }
    }

    let valueToSet;
    if (isPairingBid) {
      // Use selected value if present, otherwise use parameter.value (editing), otherwise null
      if (valueFromSelected) {
        valueToSet = valueFromSelected;
      } else if (props.parameter.value) {
        valueToSet = props.parameter.value;
      } else {
        valueToSet = null;
      }
    } else {
      // For other bids, use selected value, or fallback to value/defaultValue
      valueToSet = valueFromSelected;
      if (!valueToSet) {
        valueToSet = props.parameter.value ? props.parameter.value : props.parameter.defaultValue;
      }
    }

    // If valueToSet is a string (YYYY-MM-DD), convert to local Date object
    let finalValue = valueToSet;
    if (typeof valueToSet === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(valueToSet)) {
      const [year, month, day] = valueToSet.split('-').map(Number);
      finalValue = new Date(year, month - 1, day);
    } else if (valueToSet instanceof Date) {
      finalValue = new Date(valueToSet.getTime());
    }

    setControlledDate(finalValue || null);

    // Validate on mount/update
    if (finalValue) {
      setTimeout(() => {
        validateDateOrder(finalValue, props.allDateValues);
      }, 0);
    }
  }, [props.parameter.value]);

  // Update local error state when parent error message changes
  useEffect(() => {

    if (props.dateErrorMessage && props.dateErrorMessage.trim() !== '') {
      setDateError(true);
      setDateErrorMessage(props.dateErrorMessage);
    } else if (!props.dateErrorMessage || props.dateErrorMessage.trim() === '') {
      // Only clear local error if there's no props error message
      setDateError(false);
      setDateErrorMessage('');
    }
  }, [props.dateErrorMessage]);

  // Validate when controlled date or allDateValues change
  useEffect(() => {
    if (controlledDate && props.allDateValues) {
      validateDateOrder(controlledDate, props.allDateValues);
    }
  }, [controlledDate, props.allDateValues]);

  const buildDisabledDateComponent = () => {
    // Ensure we have a proper Date object or null for the DatePicker
    let datePickerValue = controlledDate;
    if (typeof controlledDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(controlledDate)) {
      const [year, month, day] = controlledDate.split('-').map(Number);
      datePickerValue = new Date(year, month - 1, day);
    }

    return (
      <div className="form-item-container">
        <DefaultInputLabel htmlFor={sequence}>{description}</DefaultInputLabel>

        <DefaultDatePickerProvider utils={DateFnsUtils}  locale={language === 'fr' ? frLocale : enLocale}>
          <DefaultDatePicker
            autoOk
            variant="inline"
            id={sequence}
            key={props.parameter.sequence || props.parameter.parameterSequence}
            onClick={props.handleTargetparameter}
            onChange={handleChange}
            inputVariant="outlined"
            format="yyyy-MM-dd"
            InputAdornmentProps={{ position: 'start' }}
            minDate={minDate}
            maxDate={maxDate}
            value={datePickerValue}
            shouldDisableDate={disableInactiveDates}
            error={dateError || !!props.dateErrorMessage}
            helperText={props.dateErrorMessage || dateErrorMessage}
          />
        </DefaultDatePickerProvider>
      </div>
    );
  }

  const buildDateComponent = () => {
    // Convert Date object to YYYY-MM-DD string for HTML date input
    let dateValue = controlledDate;
    if (controlledDate instanceof Date) {
      const year = controlledDate.getFullYear();
      const month = String(controlledDate.getMonth() + 1).padStart(2, '0');
      const day = String(controlledDate.getDate()).padStart(2, '0');
      dateValue = `${year}-${month}-${day}`;
    }

    // Determine final error state and message for UI
    const hasErrorForUI = dateError || !!props.dateErrorMessage;
    const errorMessageForUI = props.dateErrorMessage || dateErrorMessage;

    return (
      <div className="form-item-container">
        <DefaultInputLabel htmlFor={sequence}>{description}</DefaultInputLabel>
          <DefaultDateField
            type="date"
            mindate={minDate}
            maxdate={maxDate}
            variant="standard"
            id={sequence}
            key={props.parameter.sequence || props.parameter.parameterSequence}
            onClick={props.handleTargetparameter}
            onChange={handleChange}
            disabled={disabled}
            value={dateValue || ''}
            error={hasErrorForUI}
            helperText={errorMessageForUI}
            InputLabelProps={{
              shrink: true
            }}
          />
      </div>
    );
  }

  return (
    <React.Fragment>
      {(props.preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE || props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES || props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) ?
        buildDisabledDateComponent() : buildDateComponent()
      }
    </React.Fragment>
  );
}

const TIME = (props) => {
  const [renderParameter, setRenderParameter] = useState(true);
  const defaultTimeRaw = props.parameter.value
    ? props.parameter.value
    : props.parameter.defaultValue;

  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }
  const validHHMMstring = str => /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(str);
  let defaultTime;

  if (defaultTimeRaw === '0') defaultTime = '00:00';
  else if (validHHMMstring(defaultTimeRaw)) defaultTime = defaultTimeRaw;
  else {
    const minutes = parseInt(defaultTimeRaw) / 60;
    const hours = Math.floor(minutes);
    defaultTime = `${padTo2Digits(hours)}:00`;
  }

  const sequence = `time-picker-${props.parameter.sequence}`;

  const handleChange = (event, time) => {
    props.handleFormChange(
      event.target.value,
      time,
      event.target.value,
      props.parameter.sequence,
      'time',
      props.parameter.parameterId
    );
  };

  useEffect(() => {
    const render = parameterShouldRender(props.selectedRelation);
    setRenderParameter(render);
    if (!props.parameter.value) {
      props.parameter.defaultValue = defaultTime;
    }
  }, [props.selectedRelation, props.toggleReserved]);

  const parameterShouldRender = (selectedRelation) => {
    const { preferenceOptionId, parameter, setHiddenParameter } = props;
    let render = true;

    if (KINDOFBID.TIMEOFF_PARAMETERS_IDS.includes(preferenceOptionId)) {
      if (
        selectedRelation === VALID_RELATIONS.LESS_THAN &&
        parameter.sequence === 2
      ) {
        render = true;
      } else if (
        selectedRelation === VALID_RELATIONS.GREATER_THAN &&
        parameter.sequence === 2
      ) {
        render = true;
      } else if (selectedRelation === VALID_RELATIONS.BETWEEN) {
        render = true;
      } else if (
        selectedRelation === VALID_RELATIONS.EQUAL &&
        parameter.sequence === 2
      ) {
        render = true;
      } else {
        setHiddenParameter(parameter.parameterId);
        render = false;
      }
    }

    if (KINDOFBID.PARING_LAYOVER_PARAMETERS_IDS.includes(preferenceOptionId)) {
      if (
        selectedRelation === VALID_RELATIONS.LESS_THAN &&
        parameter.sequence === 1
      ) {
        render = true;
      } else if (
        selectedRelation === VALID_RELATIONS.GREATER_THAN &&
        parameter.sequence === 1
      ) {
        render = true;
      } else if (selectedRelation === VALID_RELATIONS.BETWEEN) {
        render = true;
      } else if (
        selectedRelation === VALID_RELATIONS.EQUAL &&
        parameter.sequence === 1
      ) {
        render = true;
      } else {
        setHiddenParameter(parameter.parameterId);
        render = false;
      }
    }
    return render;
  };

  return (
    renderParameter && (
      <div className="form-item-container">
        <DefaultInputLabel htmlFor={props.parameter.sequence}>
          {props.parameter.description}
        </DefaultInputLabel>
        <DefaultTimeField
          type="time"
          defaultValue={defaultTime}
          format="24hr"
          mode="landscape"
          style={{ zIndex: 2104 }}
          key={props.parameter.sequence}
          id={sequence}
          onClick={props.handleTargetparameter}
          onChange={e => handleChange(e)}
        />
      </div>
    )
  );
};

class DOW extends Component {
  constructor(props) {
    super(props);
    const defaultValue = props.parameter.value || props.parameter.defaultValue;
    this.state = {
      value: isNaN(defaultValue) ? defaultValue : Number(defaultValue)
    };
    this.processedRegion = false;
    this.processedSelect = false;
  }

  handleChange = (event, index, value) => {
    const {
      parameter,
      isPreferenceParameter,
      setSelectedParameterValues,
      handleFormChange
    } = this.props;
    this.setState({ value: event.target.value });

    if (isPreferenceParameter) {
      setSelectedParameterValues(
        parameter.sequence - 1,
        event.target.value,
        parameter.parameterId
      );
    } else {
      handleFormChange(
        event,
        index,
        event.target.value,
        parameter.sequence,
        parameter.type,
        parameter.parameterId
      );
    }
    if (this.props.preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE || this.props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES || this.props.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) {
      this.props.handledateselect(event.target.value, this.props.preferenceOptionId);
    }
  };

  reserveDownToAlert = () =>
    alert('You can\'t modify the avoid in reserve down to mode');

  render() {
    let allowedValues = this.props.parameter.allowedValues || {};

    const minValue = Number(this.props.parameter.minValue);
    const maxValue = Number(this.props.parameter.maxValue);
    let newDefault = false;
    const description = this.props.parameter.description
      ? this.props.parameter.description
      : ' ';
    if (Object.keys(allowedValues).length === 0 && maxValue) {
      for (let index = minValue; index <= maxValue; index += 1) {
        allowedValues[index] = index;
      }
    }
    if (this.props.kindOfOption === 'validRelations') {
      const data = Object.keys(allowedValues);
      const values = this.state.value;
      const index = data.indexOf(values);
      newDefault =
        index > -1
          ? Object.keys(allowedValues)[index]
          : Object.keys(allowedValues)[0];
    }
    let allowedValuesSorted = Object.keys(allowedValues);
    if (
      KINDOFBID.REGION_PARAMETERS_ID.includes(
        this.props.parameter.parameterId
      ) &&
      !this.processedRegion
    ) {
      Object.keys(allowedValues).forEach((key) => {
        allowedValues[key] = `${key} - ${allowedValues[key]}`;
      });
      this.processedRegion = true;
      allowedValuesSorted = Object.keys(allowedValues).sort();
    }
    if (
      KINDOFBID.PARAMETERS_WITH_KEY_VALUE_IDS.includes(
        this.props.parameter.parameterId
      ) &&
      !this.processedSelect
    ) {
      Object.keys(allowedValues).forEach((key) => {
        allowedValues[key] = `${key} - ${allowedValues[key]}`;
      });
      this.processedSelect = true;
      allowedValuesSorted = Object.keys(allowedValues).sort();
    }
    if (Object.keys(allowedValues).includes(COMPONENTS.INIT_STATION)) {
      const anyOption = Object.keys(allowedValues).filter(
        key => key === COMPONENTS.INIT_STATION
      );
      const allowedValuesFiltered = Object.keys(allowedValues)
        .filter(key => key !== COMPONENTS.INIT_STATION)
        .sort();
      allowedValues = anyOption
        .concat(allowedValuesFiltered)
        .reduce((acc, cur) => {
          acc[cur] = cur;
          return acc;
        }, {});
      allowedValuesSorted = Object.keys(allowedValues);
    }
    const options = allowedValuesSorted.map(k => (
      <MenuItem
        key={`${allowedValues[k]}${k}`}
        value={isNaN(k) ? k : Number(k)}
        data-id={`drop-down-${this.props.parameter.sequence}`}
      >
        {allowedValues[k] === k ? k : allowedValues[k]}
      </MenuItem>
    ));
    return (
      <div className="form-item-container">
        <DefaultInputLabel>{description}</DefaultInputLabel>
        <DefaultSelectField
          style={{ zIndex: 2104 }}
          value={
            this.props.toggleReserved && this.props.parameter.sequence === 9
              ? 0
              : newDefault || this.state.value
          }
          onChange={this.handleChange}
          disabled={
            !!(this.props.toggleReserved && this.props.parameter.sequence === 9)
          }
          onClick={
            this.props.toggleReserved && this.props.parameter.sequence === 9
              ? () => this.reserveDownToAlert()
              : null
          }
        >
          {options}
        </DefaultSelectField>
      </div>
    );
  }
}

const CREDIT = (props) => {
  let maxHours = props.hourMax;
  let hoursId = props.hourName;
  let minutesId = props.minuteName;
  let defaultHours = props.hourDefaultValue;
  let defaultMinutes = props.minuteDefaultValue;
  if (Object.keys(props.parameter) !== 0) {
    if (!props.isFilter) {
      const maxTime = props.parameter.maxValue;
      maxHours = Math.floor(maxTime / 60 - 1);
      hoursId = `${hoursId}-${props.parameter.sequence}`;
      minutesId = `${minutesId}-${props.parameter.sequence}`;
      const defaultValueRaw = props.value.parameterValues
        ? Number(props.value.parameterValues[0].value)
        : props.parameter.defaultValue;
      defaultHours = Math.floor(defaultValueRaw / 60);
      defaultMinutes = defaultValueRaw % 60;
    }
  }
  function handleOnChange(e) {
    const currentValue = Number(e.target.value);
    e.target.value = /^\d+$/.test(currentValue) ? currentValue : 0;
    const timeSegment = e.target.name.slice(-4);
    if (timeSegment === 'Hour') {
      const maxTime = props.hourMax;
      e.target.value = currentValue > maxTime ? maxTime : currentValue;
    } else {
      e.target.value = currentValue > 59 ? 59 : currentValue;
    }
  }
  return (
    <div>
      <div className={props.hourClassName}>
        <TextField
          name={hoursId}
          value={
            props.persistent
              ? utils.creditToHours(props.persistentCredit)
              : defaultHours
          }
          fullWidth
          type="number"
          onInput={handleOnChange}
          max={maxHours}
          min={props.hourMin}
          step={props.hourStep}
          onChange={props.handleCreditHour}
          onBlur={props.handleCreditHour}
        />
        <span className="hour-indicator">h</span>
      </div>
      <div className={props.minuteClassName}>
        <TextField
          name={minutesId}
          value={
            props.persistent
              ? utils.extractMinutes(props.persistentCredit)
              : defaultMinutes
          }
          fullWidth
          type="number"
          max={props.minuteMax}
          min={props.minuteMin}
          onInput={handleOnChange}
          step={props.minuteStep}
          onChange={props.handleCreditMinutes}
          onBlur={props.handleCreditMinutes}
        />
        <span className="minute-indicator">m</span>
      </div>
    </div>
  );
};
class WEIGHT extends Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      error: ''
    };
    this.handleWeightTextField = this.handleWeightTextField.bind(this);
  }
  handleWeightTextField = (e, index) => {
    const value1 = e.target.value.replace(/\D+/g, '');
    if (value1 > 0 && value1 < 1001) {
      this.setState({
        value: value1.replace(/\D+/g, '')
      });
      this.setState({
        error: ''
      });
      this.props.handleWeightChange(value1);
    } else if (value1 === '') {
      this.props.handleWeightChange(value1);
      this.setState({
        value: '',
        error: 'Weight value must be between 1 and 1000'
      });
    } else {
      this.setState({
        error: 'Weight value must be between 1 and 1000'
      });
    }
  };
  componentDidMount = () => {
    const value2 = this.props.value;
    this.setState({
      value: value2
    });
  };
  render() {
    const { labels } = this.context || {};
    const commonLabels = labels?.commonLabels || getLabelsFromStorage().commonLabels;
    return (
      <div className="form-item-container" style={this.state.error ? { marginBottom: '35px' } :{}}>
        <DefaultInputLabel htmlFor="text-field-weight">
          {commonLabels.WEIGHT}
        </DefaultInputLabel>
        <DefaultTextField
          onChange={this.handleWeightTextField}
          value={this.state.value}
          helperText={this.state.error}
          id={'text-field-weight'}
          type="number"
          error={!!this.state.error}
        />
      </div>
    );
  }
}
class WEIGHTMODE extends Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.state = {
      value: 2,
      error: ''
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange = (event, index, value) => {
    this.setState({ value: event.target.value, disable: false });
    this.props.handleBidMode(event.target.value);
  };
  componentDidMount = () => {
    const value2 = this.props.weight;
    this.setState({
      value: value2
    });
  };
  render() {
    const { labels } = this.context || {};
    const commonLabels = labels?.commonLabels || getLabelsFromStorage().commonLabels;
    const WEIGTH_MODE = labels?.WEIGTH_MODE || getLabelsFromStorage().WEIGTH_MODE;
    return (
      <div className="form-item-container">
        <DefaultInputLabel htmlFor="drop-down-weight">
          {commonLabels.WEIGHT}
        </DefaultInputLabel>
        <DefaultSelectField
          value={this.state.value}
          onChange={this.handleChange}
          id={'drop-down-weight'}
          autoWidth
          variant="standard"
        >
          <MenuItem key={'item_1'} value={1}>
            {WEIGTH_MODE.HIGH}
          </MenuItem>
          <MenuItem key={'item_2'} value={2}>
            {WEIGTH_MODE.MEDIUM}
          </MenuItem>
          <MenuItem key={'item_3'} value={3}>
            {WEIGTH_MODE.LOW}
          </MenuItem>
        </DefaultSelectField>
      </div>
    );
  }
}

class LADDERMODE extends Component {
  static contextType = LanguageContext;
  mounted = false;
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.bidSession.nextAvailableLevel,
      error: '',
      ladderLevels: []
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event, index, value) => {
    this.setState({ value: event.target.value, disable: false });
    this.props.handleBidMode(event.target.value);
  };

  componentDidMount = () => {
    this.mounted = true;
    const defaultValue = this.props.value
      ? this.props.value
      : this.props.weight;
    this.props.handleGetLevels(this.props).then((response) => {
      if (this.mounted) {
        this.setState({
          value: defaultValue,
          ladderLevels: response || []
        });
      }
    });
  };

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { labels } = this.context || {};
    const commonLabels = labels?.commonLabels || getLabelsFromStorage().commonLabels;
    return (
      <div className="form-item-container">
        <DefaultInputLabel htmlFor="drop-down-weight">
          {commonLabels.LEVEL}
        </DefaultInputLabel>
        <DefaultSelectField
          value={this.state.value}
          onChange={this.handleChange}
          autoWidth
          variant="standard"
        >
          {this.state.ladderLevels?.map((level, index) => (
            <MenuItem key={`item_${index}`} value={level}>
              {level}
            </MenuItem>
          ))}
        </DefaultSelectField>
      </div>
    );
  }
}

const RESERVEDOWNTO = (props) => {
  const { labels } = useContext(LanguageContext) || {};
  const commonLabels = labels?.commonLabels || getLabelsFromStorage().commonLabels;
  const [value, setValue] = useState(props.value);

  const onChange = (e) => {
    setValue(e.target.value);
    props.handleChange(e);
  };

  /* It will generate 32 elements, with 'Any' element as the first item, followed by values 0-30  */
  const numberedValues = new Array(31).fill(1).map((_, index) => {
    return {
      name: index,
      value: index + 1
    };
  });

  // Create the ANY element first, then add the numbered values
  const values = [
    {
      name: RESERVE_DOWN_TO.levelAnyText,
      value: RESERVE_DOWN_TO.levelAny
    },
    ...numberedValues
  ];

  // Filter out 0 value based on specific setting
  const filteredValues = commonLabels.HIDE_ZERO_SLOT
    ? values.filter(item => item.value !== 1)
    : values;

  const options = filteredValues.map((items, index) => (
    <MenuItem
      key={`reserve_${index}`}
      value={items.value}
      data-id={`reserve_${index}`}
    >
      {items.name}
    </MenuItem>
  ));

  return (
    <div className="form-item-container">
      <DefaultInputLabel>{props.description}</DefaultInputLabel>
      <DefaultSelectField value={value} onChange={e => onChange(e)}>
        {options}
      </DefaultSelectField>
    </div>
  );
};

TEXTFIELD.propTypes = {
  parameter: PropTypes.object,
  handleFormChange: PropTypes.func
};

TEXTFIELD.defaultProps = {
  parameter: {},
  handleFormChange: () => {}
};

LISTABLEDATE.propTypes = {
  parameter: PropTypes.object,
  handleFormChange: PropTypes.func,
  handleTargetparameter: PropTypes.func,
  disabled: PropTypes.bool,
  kindOfBid: PropTypes.string,
  preferenceOptionId: PropTypes.number,
  minDate: PropTypes.string,
  secondDate: PropTypes.string,
  pairingdate: PropTypes.object,
  pairingName: PropTypes.string,
  disableDialogSaveButton: PropTypes.func,
  setSelectedParameterValues: PropTypes.func,
  classOptionAttributes: PropTypes.object,
  allDateValues: PropTypes.object,
  onDateError: PropTypes.func,
  selectedParameterValues: PropTypes.array,
  dateErrorMessage: PropTypes.string,
};

LISTABLEDATE.defaultProps = {
  parameter: {},
  handleFormChange: () => {},
  handleTargetparameter: () => {},
  disabled: true,
  kindOfBid: '',
  preferenceOptionId: 0,
  minDate: '',
  secondDate: '',
  pairingName: '',
  pairingdate: {},
  disableDialogSaveButton: () => {},
  setSelectedParameterValues: () => {},
  classOptionAttributes: null,
  allDateValues: {},
  onDateError: () => {},
  selectedParameterValues: [],
  dateErrorMessage: '',
};

TIME.propTypes = {
  parameter: PropTypes.object,
  handleFormChange: PropTypes.func,
  handleTargetparameter: PropTypes.func,
  toggleReserved: PropTypes.bool
};

CREDIT.propTypes = {
  hourName: PropTypes.string.isRequired, // String id-react
  hourHintText: PropTypes.any, // Placeholder
  hourDefaultValue: PropTypes.any, // Default value hours|
  handleCreditHour: PropTypes.func.isRequired, // Function Onchange -- On Input --
  hourMax: PropTypes.number.isRequired, // Max-hours
  hourMin: PropTypes.number.isRequired, // Min-hours
  hourStep: PropTypes.number.isRequired, // Step 1-1 15-15
  hourClassName: PropTypes.string, // Class for texfield
  minuteName: PropTypes.string.isRequired, // String id-react
  minuteHintText: PropTypes.any, // Placeholder
  minuteDefaultValue: PropTypes.any, // Minutes defaut value
  handleCreditMinutes: PropTypes.func.isRequired, // function Onchange
  minuteMax: PropTypes.number.isRequired, // Max minutes
  minuteMin: PropTypes.number.isRequired, // Min minutes
  minuteStep: PropTypes.number.isRequired, // Step Minutes
  minuteClassName: PropTypes.string, // Class got texfield
  parameter: PropTypes.object,
  value: PropTypes.object,
  persistent: PropTypes.bool,
  persistentCredit: PropTypes.number,
  isFilter: PropTypes.bool
};

TIME.defaultProps = {
  parameter: {},
  handleFormChange: () => {},
  handleTargetparameter: () => {},
  toggleReserved: false
};

DOW.propTypes = {
  parameter: PropTypes.object,
  handleFormChange: PropTypes.func,
  kindOfOption: PropTypes.string,
  isPreferenceParameter: PropTypes.bool,
  setSelectedParameterValues: PropTypes.func,
  preferenceOptionId: PropTypes.number
};

DOW.defaultProps = {
  parameter: {},
  handleFormChange: () => {},
  kindOfOption: '',
  isPreferenceParameter: false,
  setSelectedParameterValues: () => {},
  preferenceOptionId: 0
};

FLYTEXTFIELD.propTypes = {
  parameter: PropTypes.object,
  handleFormChange: PropTypes.func,
  setSelectedParameterValues: PropTypes.func
};
FLYTEXTFIELD.defaultProps = {
  parameter: {},
  handleFormChange: () => {},
  setSelectedParameterValues: () => {}
};

CREDIT.defaultProps = {
  hourname: '',
  hourHintText: '',
  hourDefaultValue: 0,
  minuteName: '',
  minuteHintText: '',
  minuteDefaultValue: 0,
  hourClassName: '',
  minuteClassName: '',
  parameter: {},
  value: {},
  persistent: false,
  persistentCredit: 0,
  isFilter: false
};
WEIGHT.propTypes = {
  value: PropTypes.number,
  handleWeightChange: PropTypes.func,
  handleTargetparameter: PropTypes.func
};

WEIGHT.defaultProps = {
  value: 0,
  handleWeightChange: () => {},
  handleTargetparameter: () => {}
};
WEIGHTMODE.propTypes = {
  weight: PropTypes.number,
  handleBidMode: PropTypes.func,
  handleTargetparameter: PropTypes.func
};

WEIGHTMODE.defaultProps = {
  weight: 2,
  handleBidMode: () => {},
  handleTargetparameter: () => {}
};

LADDERMODE.propTypes = {
  weight: PropTypes.number,
  handleBidMode: PropTypes.func,
  handleGetLevels: PropTypes.func,
  handleTargetparameter: PropTypes.func
};

LADDERMODE.defaultProps = {
  weight: 1,
  handleBidMode: () => {},
  handleGetLevels: () => {},
  handleTargetparameter: () => {}
};

export {
  LISTABLEDATE,
  TIME,
  DOW,
  CREDIT,
  MULTISELECT,
  FLYTEXTFIELD,
  WEIGHT,
  WEIGHTMODE,
  LADDERMODE,
  RESERVEDOWNTO
};
